<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uMLWkn/tc-custom/9781035805709.jpg?1718183630306" alt="This image is the cover for the book My Dream With Bear"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Dream With Bear
      </h1>
      <p class="bookDescription body article font2">
        <p>Have you ever climbed a tree or had a cuppa tea… with a bear? <br/>During a dream, a little boy does just that! <br/>At first, he was quite frightened. <br/>But, when he takes the time to listen and be compassionate to a funny looking lonely bear, not only does he have a wonderful time, he also makes a new friend!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lexie Bobs, Katie Grace Byrne
      </h2>
      
      <p class="authorDescription body article">Lexie Bobs is an Aussie girl, born and bred in Tropical Far North Queensland. Lex has always loved to tell stories and make up rhymes. She loves picture books that teach children good morals to help mold their lives, allow their imaginations to run free and most importantly, bring them joy. When Lex isn’t busy writing new adventures, she loves to camp, kayak, watch movies or do anything creative.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d9beb63